import type { BaseKeyFunction } from "../../../../../../lib";

export type KeyCommunitiesMostPopularProps = {
  id: number;
};

export const keyCommunitiesMostPopular: BaseKeyFunction<
  KeyCommunitiesMostPopularProps
> = ({ id }) => ["communities-most-popular", id?.toString()];
